module.exports = __webpack_public_path__ + "img/JSD300.0f330a56.png";